import React, { useEffect } from 'react';
import config from '../../config';
import FullScreenLoader from './FullScreenLoader';

const onlineClientUrlRoot = config.onlineClientUrlRoot || config.urlRoot;

const AbsoluteRedirect = ({
  pathname,
  search,
  fullPath,
  onlineClient = false,
}) => {
  useEffect(() => {
    if (!fullPath && !pathname) {
      window.location = '/';
    }
    const url =
      fullPath ||
      `${
        onlineClient ? onlineClientUrlRoot : config.urlRoot
      }${pathname}${search}`;

    if (
      url.toLowerCase().startsWith('http://') ||
      url.toLowerCase().startsWith('https://')
    ) {
      window.location = url;
    }
  }, []);
  return <FullScreenLoader />;
};

export default AbsoluteRedirect;
